import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageCircle, Clock } from 'lucide-react';
const SUPPORT_EMAIL = 'elementaldealsandshop@gmail.com';
export function Support() {
  return <section id="soporte" className="py-24 md:py-32 relative overflow-hidden border-t border-gold/10" data-id="element-312">
      {/* Cinematic background glow */}
      <div className="absolute inset-0 bg-black-100/30" data-id="element-313">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[600px] bg-[radial-gradient(ellipse_at_center,rgba(212,175,122,0.12)_0%,transparent_65%)] blur-3xl pointer-events-none" data-id="element-314"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-315">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative" data-id="element-316">
          {/* Glow underneath card */}
          <div className="absolute -inset-px bg-gradient-to-br from-gold/30 via-gold/5 to-transparent rounded-sm blur-md opacity-50 pointer-events-none" data-id="element-317"></div>

          <div className="relative bg-gradient-to-br from-black-100 to-black border border-gold/20 rounded-sm overflow-hidden shadow-2xl" data-id="element-318">
            {/* Top hairline */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" data-id="element-319"></div>

            <div className="grid lg:grid-cols-2 gap-0" data-id="element-320">
              {/* LEFT: Text */}
              <div className="p-10 md:p-14 lg:p-16 lg:border-r lg:border-gold/10" data-id="element-321">
                <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6" data-id="element-322">
                  Soporte · Estamos aquí
                </p>
                <h2 className="font-display text-3xl md:text-5xl text-cream mb-6 leading-[1.05]" data-id="element-323">
                  ¿Necesitas <span className="text-gold italic" data-id="element-324">ayuda?</span>
                </h2>
                <p className="text-cream/65 text-base md:text-lg font-light leading-[1.7] mb-8" data-id="element-325">
                  Nuestro equipo está disponible para resolver cualquier duda
                  antes o después de tu compra. No importa si es sobre el
                  acceso, los prompts, o si quieres recomendaciones para tu
                  negocio — escríbenos y te respondemos personalmente.
                </p>

                <div className="space-y-4" data-id="element-326">
                  <div className="flex items-center gap-4 text-cream/70 text-sm" data-id="element-327">
                    <div className="w-9 h-9 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-328">
                      <Clock size={14} className="text-gold" data-id="element-329" />
                    </div>
                    <span data-id="element-330">Respuesta promedio en menos de 24 horas</span>
                  </div>
                  <div className="flex items-center gap-4 text-cream/70 text-sm" data-id="element-331">
                    <div className="w-9 h-9 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-332">
                      <MessageCircle size={14} className="text-gold" data-id="element-333" />
                    </div>
                    <span data-id="element-334">Atención humana y personalizada</span>
                  </div>
                </div>
              </div>

              {/* RIGHT: Email CTA */}
              <div className="p-10 md:p-14 lg:p-16 bg-gradient-to-br from-black to-black-200 flex flex-col justify-center relative overflow-hidden" data-id="element-335">
                {/* Subtle inner glow */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(212,175,122,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-336"></div>

                <div className="relative z-10" data-id="element-337">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 mb-8 shadow-[0_0_30px_rgba(212,175,122,0.2)]" data-id="element-338">
                    <Mail size={24} className="text-gold" data-id="element-339" />
                  </div>

                  <p className="text-[10px] uppercase tracking-[0.3em] text-cream/50 mb-3" data-id="element-340">
                    Escríbenos a
                  </p>

                  <a href={`mailto:${SUPPORT_EMAIL}`} className="block font-display text-xl md:text-2xl lg:text-[28px] text-gold hover:text-gold-light transition-colors leading-tight break-all mb-8" style={{
                  textShadow: '0 0 30px rgba(212,175,122,0.25)'
                }} data-id="element-341">
                    {SUPPORT_EMAIL}
                  </a>

                  <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 px-6 py-3 bg-gold text-black rounded-sm text-xs uppercase tracking-widest font-medium hover:bg-gold-light shadow-[0_0_20px_rgba(212,175,122,0.2)] hover:shadow-[0_0_30px_rgba(212,175,122,0.4)] transition-all" data-id="element-342">
                    <Mail size={14} data-id="element-343" />
                    Enviar correo
                  </a>

                  <p className="text-cream/40 text-xs mt-8 italic font-light" data-id="element-344">
                    O simplemente copia el correo y escríbenos desde tu cliente
                    favorito.
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom hairline */}
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-345"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}